import ConfigManager from '@/config/ConfigManager.js';
import CacheHelper from "@/helper/CacheHelper";

const KEY_COOKIE_RETURN_URL = 'return_url';

export default {
    getCacheReturnUrl: function () {
        let cache = new CacheHelper(ConfigManager.getCacheType());
        let cacheReturnUrl = cache.getCache(KEY_COOKIE_RETURN_URL);
        cache.removeCache(KEY_COOKIE_RETURN_URL);
        return cacheReturnUrl;
    },

    setCacheReturnUrl: function (returnUrl) {
        let cache = new CacheHelper(ConfigManager.getCacheType());
        cache.setCache(KEY_COOKIE_RETURN_URL, returnUrl);
    },

    removeCacheReturnUrl: function () {
        let cache = new CacheHelper(ConfigManager.getCacheType());
        cache.removeCache(KEY_COOKIE_RETURN_URL);
    }
};
